import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import Format from '../../../Services/Format';
import { PaymentTotal } from '../useSalesAnalytics';
import * as S from './styles';

const compactCurrency = (value: number) => {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(0)}mil`;
  return String(Math.round(value));
};

function PaymentTooltip({ active, payload }: any) {
  if (!active || !payload?.length) return null;
  const point = payload[0]?.payload;

  return (
    <S.TooltipCard>
      <span className="name">{point?.name}</span>
      <span>{Format.formatCurrencyBr(point?.total)}</span>
      <span>
        {point?.orders} pedido{Number(point?.orders) === 1 ? '' : 's'}
      </span>
    </S.TooltipCard>
  );
}

export function PaymentMethods({
  payments,
  isFetching,
  errorMessage,
}: {
  payments: PaymentTotal[];
  isFetching?: boolean;
  errorMessage?: string | null;
}) {
  // Barras horizontais: a altura acompanha a quantidade de formas de pagamento.
  const height = Math.max(200, payments.length * 42 + 40);

  return (
    <S.Container>
      <h3>Métodos de Pagamento</h3>

      {payments.length > 0 ? (
        <div className="chart">
          <ResponsiveContainer width="100%" height={height}>
            <BarChart
              data={payments}
              layout="vertical"
              margin={{ top: 8, right: 16, left: 8, bottom: 0 }}
            >
              <CartesianGrid horizontal={false} strokeDasharray="4 8" stroke="#EEF0F5" />

              <XAxis
                type="number"
                stroke="#9CA3AF"
                tickLine={false}
                axisLine={false}
                tick={{ fontSize: 11, fill: '#6B7280' }}
                tickFormatter={compactCurrency}
              />

              <YAxis
                type="category"
                dataKey="name"
                stroke="#9CA3AF"
                tickLine={false}
                axisLine={false}
                tick={{ fontSize: 12, fill: '#374151' }}
                width={110}
              />

              <Tooltip
                cursor={{ fill: 'rgba(79, 70, 229, 0.08)' }}
                content={<PaymentTooltip />}
              />

              <Bar dataKey="total" fill="#4F46E5" radius={[0, 4, 4, 0]} maxBarSize={26} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className={errorMessage ? 'not-data error' : 'not-data'}>
          {errorMessage
            ? `Não foi possível carregar as vendas: ${errorMessage}`
            : isFetching
            ? 'Carregando vendas do período…'
            : 'Nenhuma venda no período selecionado.'}
        </div>
      )}
    </S.Container>
  );
}
